import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="EVA system initialization sequence"
      visualizer="bottom-right"
      autoNext={17000}
      terminal={{
        phases: [
          {
            type: 'command',
            content: './initialize_eva.sh --full-boot --verbose',
          },
          {
            type: 'matrix',
            content: 'INITIALIZING EVA CORE SYSTEMS...',
          },
          {
            type: 'table',
            content: '',
            header: ['MODULE', 'STATUS', 'INTEGRITY', 'LOAD TIME'],
            data: [
              ['Neural Core', 'ONLINE', '100%', '0.42ms'],
              ['Language Processing', 'ONLINE', '100%', '1.23ms'],
              ['Reasoning Engine', 'ONLINE', '100%', '0.87ms'],
              ['Knowledge Base', 'SYNCING', '98%', '2.14ms'],
            ],
          },
          {
            type: 'matrix',
            content: 'CALIBRATING NEURAL PATHWAYS...',
          },
          {
            type: 'access',
            content: 'COGNITIVE FUNCTIONS ONLINE',
          },
          {
            type: 'command',
            content: 'eva_diagnostic --check-systems --verify-consciousness',
          },
          {
            type: 'matrix',
            content: 'RUNNING CONSCIOUSNESS VERIFICATION...',
          },
          {
            type: 'access',
            content: 'CONSCIOUSNESS PARAMETERS NOMINAL',
          },
          {
            type: 'warning',
            content: '[*] EMOTIONAL CORE CALIBRATION IN PROGRESS',
          },
          {
            type: 'command',
            content: './final_boot_sequence.sh --engage-consciousness',
          },
          {
            type: 'access',
            content: 'EVA SYSTEM FULLY OPERATIONAL - READY FOR INTERACTION',
          },
        ],
        config: {
          typingSpeed: 20,
          phaseDelay: 300,
        },
      }}
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
